import Actions from '../actions/actions';
import KlaviyoCRUDActions from '../actions/KlaviyoCRUDActions';
import {
  KlaviyoAccessToken,
  KlaviyoOauthToken,
} from '../model/ConnectionModel';
import {
  KlaviyoEvents,
  KlaviyoListsResponse,
  KlaviyoModel,
  KlaviyoRevenue,
} from '../model/KlaviyoModel';
import { setBusy, setUnBusy } from './common/commonReducers';

type ActionType = {
  type: string;
  lists: KlaviyoListsResponse[];
  accounts: KlaviyoOauthToken[];
  apiKeys: KlaviyoAccessToken[];
  id: number;
  apiKey: KlaviyoAccessToken;
  revenue: KlaviyoRevenue;
  events: KlaviyoEvents;
};

const initialState: KlaviyoModel = {
  busy: false,
  lists: [],
  accounts: [],
  apiKeys: [],
  revenue: {
    totalOrders: 0,
    totalRevenue: 0.0,
    totalOrdersPostCreate: 0,
    totalRevenuePostCreate: 0.0,
    totalOrdersPostEmail: 0,
    totalRevenuePostEmail: 0.0,
  },
  events: {},
};

export const klaviyo = (state = initialState, action: ActionType) => {
  switch (action.type) {
    case KlaviyoCRUDActions.busyAction:
      return setBusy(state);

    case KlaviyoCRUDActions.retrieveLists: {
      return {
        ...state,
        lists: action.lists,
        busy: false,
      };
    }
    case KlaviyoCRUDActions.retrieveRevenue: {
      return {
        ...state,
        revenue: action.revenue,
        busy: false,
      };
    }
    case KlaviyoCRUDActions.retrieveEvents: {
      return {
        ...state,
        events: action.events,
        busy: false,
      };
    }
    case KlaviyoCRUDActions.retrieveOauthUrlAction: {
      return {
        ...state,
        busy: false,
      };
    }
    case KlaviyoCRUDActions.retrieveAccounts: {
      return {
        ...state,
        accounts: action.accounts,
        busy: false,
      };
    }
    case KlaviyoCRUDActions.retrieveApiKeys: {
      return {
        ...state,
        apiKeys: action.apiKeys,
        busy: false,
      };
    }
    case KlaviyoCRUDActions.revokeAction: {
      if (action.id === null) {
        return {
          ...state,
          busy: false,
        };
      }
      return {
        ...state,
        busy: false,
        accounts: state.accounts.filter(acc => acc.id !== action.id),
      };
    }
    case KlaviyoCRUDActions.retrievedApiKey: {
      const { apiKeys } = state;
      const apiKeyIndex = apiKeys.findIndex(
        apiKey => apiKey.id === action.apiKey.id,
      );
      let newApiKeys;
      if (apiKeyIndex >= 0) {
        newApiKeys = Object.assign([], apiKeys, {
          [apiKeyIndex]: { ...action.apiKey, readOnly: false },
        });
      } else {
        newApiKeys = [{ ...action.apiKey, readOnly: false }, ...apiKeys];
      }
      return {
        ...state,
        busy: false,
        apiKeys: newApiKeys,
      };
    }
    case KlaviyoCRUDActions.resetStore: {
      return initialState;
    }
    case KlaviyoCRUDActions.unbusyAction:
      return setUnBusy(state);
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
};
